export const lang = {
  lang: 'English',
};
